module.exports = __webpack_public_path__ + "img/isologo-white-garage.413dbe81.png";